import Api from '../../../common/services/api';

export const ADMIN_CREATE_TEAM = 'admin/CREATE_TEAM';

export default (values) => async (dispatch, getState) => {
  const { network: { selected } } = getState();

  const { data: team } = await Api.post(`/v2/networks/${selected}/teams`, {
    name: values.name,
    userIds: values.members.add,
    functionIds: values.functionIds
  });

  console.log('debug create-team, API team', team);

  return dispatch({
    type: ADMIN_CREATE_TEAM,
    team,
  });
};
